import React, { useRef, useEffect, useState } from "react"
import { SwitchTransition, CSSTransition } from "react-transition-group"
import Splitting from 'splitting'

const timeout = 1400 // same as css

const Transition = ({ children, location, pageName }) => {

	const sailEl = useRef(null)
	const textEl = useRef(null)
	// const [text, setText] = useState('')

	useEffect(() => {
		const splitEl = document.createElement('p')
		splitEl.innerHTML = pageName === 'homepage' ? 'proof' : pageName
		const results = Splitting({target: splitEl, by: 'chars' })
		textEl.current.innerHTML = ''
		if (results[0]) {
			textEl.current.appendChild(results[0].el)
		}
	}, [pageName])

	const handleExit = () => {
		document.body.classList.add('noScroll')
		sailEl.current.classList.add('entering')
		setTimeout(() => {
			sailEl.current.classList.remove('entering')
			sailEl.current.classList.add('entered')
			window.scrollTo(0, 0)
		}, timeout)
	}

	const handleEnter = () => {
		document.body.classList.remove('noScroll')
		sailEl.current.classList.remove('entered')
		sailEl.current.classList.add('leaving')
		setTimeout(() => {
			sailEl.current.classList.remove('leaving')
		}, timeout)
	}

	return (
		<>
			<SwitchTransition mode="out-in">
				<CSSTransition
					key={location.pathname}
					timeout={timeout}
					onExit={handleExit}
					onEnter={handleEnter}
				>
					{children}
				</CSSTransition>
			</SwitchTransition>
			<div className="Transition__Sail" ref={sailEl}>
				<p className="Transition__SailText" ref={textEl}>
				</p>
			</div>
		</>
	)

}
export default Transition